import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICON } from '@core/util/icon';
import { openClose } from '@core/animations/animations';
import { RequestForFundsSelectors } from '../../../../closer-sync-rff/request-for-funds.selector';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { MatterMortgagesState } from '@state/matter/matter_mortgages';
import { FundingType, MatterMortgageWithAssociations } from '@models/mortgage';
import { BUTTON_PRESETS } from 'src/app/ui/button/button.component';
@Component({
	selector: 'app-funding-option',
	templateUrl: './funding-option.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [openClose()],
	standalone: false,
})
export class FundingOptionComponent {
	@Select(RequestForFundsSelectors.ValidateFundingDetails)
	validateFundingDetails$: Observable<any>;
	@Select(MatterMortgagesState.getSelectedMortgage)
	mortgage$: Observable<MatterMortgageWithAssociations>;

	_validateFundingDetails: any;
	public isOpened = true;
	public ICON = ICON;
	public fundingType = FundingType;

	BUTTON_PRESETS = BUTTON_PRESETS;

	toggleContainer(): void {
		this.isOpened = !this.isOpened;
	}
}
